import React from 'react';
import { TuitionTable } from './TuitionTable';

export { TuitionPage };

function TuitionPage() {
    return (
        <div className="p-4">
            <TuitionTable />
        </div>
    );
}
